import React from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { getItemCsv, getListCsv } from "../../../features/order/orderSlice";
import { setToken } from "../../../features/auth/authSlice";

const SalesStore = ({ dataDetail, token }) => {
  const items = dataDetail?.estimation?.items;

  const dispatch = useDispatch();

  const getItemCsvHandler = (e) => {
    e.preventDefault();
    const data = {
      order_key: dataDetail.order_key,
    };
    dispatch(getItemCsv({ data, token }))
      .unwrap()
      .then(({ res, newToken }) => {
        if (res && res.data.result === "success") {
          const fileData = res.data.value.file_data;
          const fileName = res.data.value.file_name;

          fetch("data:text/plain;charset=UTF-8;base64," + fileData)
            .then((response) => response.blob())
            .then((data) => {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(data);
              a.target = "_blank";
              a.download = fileName;
              a.click();
            });
          if (res.data && res.data.result === "success" && newToken) {
            dispatch(setToken(newToken));
          }
        }
      })
      .catch((error) => {
        if (error.error_message === "ファイルデータ取得エラー") {
          toast.error("ファイルデータ取得エラー");
        }
      });
  };
  const getListCsvHandler = (e) => {
    e.preventDefault();
    const data = {
      order_key: dataDetail.order_key,
    };
    dispatch(getListCsv({ data, token }))
      .unwrap()
      .then(({ res, newToken }) => {
        if (res && res.data.result === "success") {
          const fileData = res.data.value.file_data;
          const fileName = res.data.value.file_name;

          fetch("data:text/plain;charset=UTF-8;base64," + fileData)
            .then((response) => response.blob())
            .then((data) => {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(data);
              a.target = "_blank";
              a.download = fileName;
              a.click();
            });
          if (res.data && res.data.result === "success" && newToken) {
            dispatch(setToken(newToken));
          }
        }
      })
      .catch((error) => {
        if (error.error_message === "ファイルデータ取得エラー") {
          toast.error("ファイルデータ取得エラー");
        }
      });
  };

  return (
    <div className="order__detail_store w-full flex flex-col mt-8">
      <table className="w-[100%] text-left text-sm md:text-base">
        <thead>
          <tr>
            <th
              colSpan="4"
              className="bg-primary bg-opacity-50 font-bold px-2 py-[4px] border-[1px] border-black"
            >
              販売店情報
            </th>
          </tr>
        </thead>
        {items &&
          items.map((item, idx) => (
            <tbody key={idx} className="w-12/12">
              <tr className="border-[1px] border-black bg-blue-300">
                <td colSpan="4">
                  <div className="flex gap-4">
                    <p>{item.brand_name}</p>
                    <p>
                      部数:{" "}
                      <span className="font-semibold">{item.quantity}</span>
                    </p>
                    <p>
                      単価:{" "}
                      <span className="font-semibold">
                        {item.each_unit_price}
                      </span>
                    </p>
                  </div>
                </td>
              </tr>
              <tr className="border-[1px] border-black font-semibold">
                <td>販売店 CD</td>
                <td>店名</td>
                <td>部数</td>
                <td>単価</td>
              </tr>
              {item?.sales_stores?.map((store, idx) => (
                <tr key={idx} className="border-[1px] border-black">
                  <td className="w-3/12">{store.store_cd}</td>
                  <td className="w-3/12">{store.store_name}</td>
                  <td className="w-3/12">{store.quantity}</td>
                  <td className="w-3/12">{store.each_unit_price?.toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          ))}
      </table>
      <div className="flex w-full justify-end gap-2 mt-4 mb-4">
        <button
          onClick={(e) => getItemCsvHandler(e)}
          className="px-4 py-2 bg-blue-600 text-white"
        >
          新聞販売店リスト(詳細)
        </button>
        <button
          onClick={(e) => getListCsvHandler(e)}
          className="px-4 py-2 bg-blue-600 text-white"
        >
          新聞販売店リスト
        </button>
      </div>
    </div>
  );
};

export default SalesStore;
